import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog';
import { PaperArrastavel } from '../dialog-arrastavel/PaperArrastavel';
import { SimuladorPrecoContainer, SimuladorPrecoContainerProps } from './SimuladorPrecoContainer';
import { DialogContent, DialogTitle } from '@mui/material';
import { SeparadorSimpes } from '../separador/Separador';


const SimuladorPrecoContainerDialog = (props:SimuladorPrecoContainerProps) => {
    const [open,setOpen] = useState(true)
    
    return <>
        <Dialog open={open} maxWidth="md"
            id="SimladorPrecoContainerDialog"
            PaperComponent={PaperArrastavel}
        >
            <DialogTitle id="SimladorPrecoContainerDialog_Titulo">
                <>{props.somenteLeitura ? "Composição de Preço" : "Simulador de Preço"}</>
                <SeparadorSimpes />
            </DialogTitle>
            <DialogContent id="SimladorPrecoContainerContent">
                <SimuladorPrecoContainer {...props}
                    onCancelar={() => {
                        setOpen(false)
                        props.onCancelar()
                    }}/>
            </DialogContent>
        </Dialog>
    </>
}

export {
    SimuladorPrecoContainerDialog
}

